<template>
  <div>
    <div class="report-summary-header mg-b-5 mg-t-0">
      <div>
        <h4 class="tx-inverse mg-b-3">Documentos do Processo</h4>
        <p class="mg-b-0">
          <i class="icon ion-information-circled mg-r-3"></i> Visualização do
          documentos enviados e upload de novos documentos para o processo.
        </p>
      </div>
      <div></div>
    </div>

    <div class="row">
      <div class="card wd-100p">
        <div class="card-header">
          <ul class="nav nav-tabs card-header-tabs">
            <li class="nav-item">
              <a
                class="nav-link active"
                href="#documentos-enviados"
                data-toggle="tab"
                @click="loadDocuments()"
              >
                <i class="fa fa-file-text-o mg-r-2"></i> Documentos Enviados
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#documentos-enviar" data-toggle="tab">
                <i class="fa fa-upload mg-r-2"></i> Enviar Documentos
              </a>
            </li>
          </ul>
        </div>
        <div class="card-body">
          <div class="tab-content ht-100p">
            <div class="tab-pane active" id="documentos-enviados">
              <div class="report-summary-header mg-b-5 mg-t-0">
                <div>
                  <h4 class="tx-inverse mg-b-3">Documentos Enviados</h4>
                  <p class="mg-b-0">
                    <i class="icon ion-information-circled mg-r-3"></i> Foram
                    encontrados {{ documents.length }} documentos que foram
                    enviados para este processo.
                  </p>
                </div>
                <div class="d-flex align-items-end" style="gap: 10px;">
                  <div
                    class="d-flex flex-column"
                    style="gap: 4px;"
                    v-if="documentSearch === ''"
                  >
                    <span class="doc-filtro-label">Filtrar por documento</span>
                    <div class="doc-filtro-group">
                      <button
                        type="button"
                        class="doc-filtro-pill"
                        :class="{ 'doc-filtro-pill-on': documentFilter === 'all' }"
                        @click="documentFilter = 'all'"
                      >
                        Todos
                      </button>
                      <button
                        type="button"
                        class="doc-filtro-pill"
                        :class="{ 'doc-filtro-pill-on': documentFilter === 'with' }"
                        @click="documentFilter = 'with'"
                      >
                        Com documento
                      </button>
                      <button
                        type="button"
                        class="doc-filtro-pill"
                        :class="{ 'doc-filtro-pill-on': documentFilter === 'without' }"
                        @click="documentFilter = 'without'"
                      >
                        Sem documento
                      </button>
                    </div>
                  </div>
                  <div class="search-box doc-search-box">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Pesquisar"
                      v-model="documentSearch"
                    />
                    <button class="btn btn-primary">
                      <i class="fa fa-search" style="margin-left: -5px"></i>
                    </button>
                  </div>
                </div>
              </div>

              <hr />

              <div class="mg-l-0 row">
                <template v-if="documentSearch != ''">
                  <div class="col-12" v-if="listOfDocuments.length == 0">
                    <div
                      class="bd-l bd-3 bd-danger bg-gray-200 pd-x-20 pd-y-25"
                    >
                      <h5 class="tx-danger">Pesquisa dos Documentos</h5>
                      <p class="mg-b-0">
                        Nenhum documento que contenha a Descrição ou Tipo
                        <strong>{{ documentSearch }}</strong> foi encontrado.
                      </p>
                    </div>
                  </div>
                  <div
                    class="list-group list-group-striped list-group-user col-12"
                  >
                    <div
                      v-for="document in listOfDocuments"
                      :key="document.id"
                      class="list-group-item"
                    >
                      <div
                        class="user-name-address"
                        @click="download(document)"
                      >
                        <p>
                          <i class="icon ion-android-attach"></i>
                          {{ document.description }}
                        </p>
                        <span>
                          <i class="fa fa-flag tx-gray-500"></i>
                          {{ document.documentTypeName }}
                        </span>
                        <small
                          v-if="
                            document.legacyCreated !== null &&
                            document.legacyCreatedBy !== null
                          "
                        >
                          Enviando em
                          {{
                            document.legacyCreated
                              | moment("DD/MM/YY à\\s HH:mm:ss")
                          }}
                          por {{ document.legacyCreatedBy }}
                        </small>
                        <small v-else>
                          Enviando em
                          {{
                            document.created | moment("DD/MM/YY à\\s HH:mm:ss")
                          }}
                          por {{ document.createdBy }}
                        </small>
                      </div>
                      <div class="user-btn-wrapper tx-26">
                        <a
                          v-if="podeVisualizar(document)"
                          href="#"
                          class="mg-r-10"
                          title="Visualizar"
                          @click.stop="visualizar(document)"
                          ><i class="fa fa-eye tx-primary"></i
                        ></a>
                        <a
                          href="#"
                          class="mg-r-10"
                          @click.stop="download(document)"
                          ><i class="fa fa-download tx-primary"></i
                        ></a>
                        <a href="#" @click.stop="remover(document)"
                          ><i class="icon ion-trash-b tx-danger"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="col-12"
                    v-if="
                      documentFilter === 'with' &&
                      filteredDocumentTypes.length === 0
                    "
                  >
                    <div class="bd-l bd-3 bd-warning bg-gray-200 pd-x-20 pd-y-25">
                      <p class="mg-b-0">
                        O processo ainda não possui documentos anexados.
                      </p>
                    </div>
                  </div>
                  <div
                    v-for="documentType in filteredDocumentTypes"
                    :key="documentType.id"
                    class="pd-t-10 dropdown dropdown-c col-4 mg-t-20 mg-b-0 mg-md-t-0-force bd-b pd-b-10"
                  >
                    <label class="section-label tx-13 tx-gray-700">
                      <i
                        class="fa fa-check tx-success mg-r-8"
                        v-if="
                          documentType.docs !== undefined &&
                          documentType.docs.length > 0
                        "
                      ></i>
                      <i class="fa fa-check tx-danger mg-r-8" v-else></i>
                      {{ documentType.description }}
                    </label>

                    <div
                      class="card-footer pd-y-5 pd-x-10 bd-t bd-gray-300 bd"
                      data-toggle="dropdown"
                    >
                      <a href="#" class="tx-11 tx-uppercase"
                        >Visualizar Documentos ({{
                          documentType.docs !== undefined
                            ? documentType.docs.length
                            : "0"
                        }}) <i class="fa fa-angle-down"></i
                      ></a>
                    </div>

                    <div
                      class="file-group dropdown-menu dropdown-menu-left pd-0 wd-600 bd-0"
                    >
                      <div
                        class="card-header d-flex align-items-center justify-content-between pd-y-20 bd-gray-400 bd-2 bd-b-gray-800 bg-gray-400"
                      >
                        <h6 class="mg-b-0 tx-13 tx-inverse">
                          {{ documentType.description }}
                        </h6>
                        <a
                          href="#"
                          class="tx-11 tx-uppercase tx-primary"
                          v-if="
                            documentType.docs !== undefined &&
                            documentType.docs.length > 1
                          "
                          @click.stop.prevent="baixarTodos(documentType)"
                          ><i class="fa fa-download mg-r-3"></i>Baixar
                          Todos</a
                        >
                      </div>

                      <template
                        v-if="
                          documentType.docs !== undefined &&
                          documentType.docs.length > 0
                        "
                      >
                        <perfect-scrollbar
                          style="max-height: 300px !important"
                          @mousedown.native.stop
                          @click.native.stop
                        >
                          <div
                            class="file-item bd-1 bd-gray-200 bg-gray-100 pd-t-10 pd-b-10 ht-70"
                            v-for="doc in documentType.docs"
                            :key="'doc-' + doc.id"
                          >
                            <div class="row no-gutters wd-100p">
                              <div
                                class="col-9 mg-t-5 mp-hand"
                                @click="download(doc)"
                              >
                                <i class="fa fa-file"></i>
                                <a href="#"> {{ doc.description }}</a>
                                <span class="tx-right tx-12 tx-thin mg-l-10"
                                  >({{ doc.documentTypeName }})</span
                                >
                              </div>

                              <div class="col-3 tx-right tx-26">
                                <a
                                  v-if="podeVisualizar(doc)"
                                  href="#"
                                  class="mg-r-5"
                                  title="Visualizar"
                                  @click.stop="visualizar(doc)"
                                  ><i class="fa fa-eye tx-primary"></i
                                ></a>
                                <a
                                  href="#"
                                  class="mg-r-5"
                                  @click.stop="download(doc)"
                                  ><i class="fa fa-download tx-primary"></i
                                ></a>
                                <a href="#" @click.stop="remover(doc)"
                                  ><i class="icon ion-trash-b tx-danger"></i
                                ></a>
                              </div>

                              <small
                                class="col-12"
                                v-if="
                                  doc.legacyCreated !== null &&
                                  doc.legacyCreatedBy !== null
                                "
                              >
                                Enviando em
                                {{
                                  doc.legacyCreated
                                    | moment("DD/MM/YY à\\s HH:mm:ss")
                                }}
                                por {{ doc.legacyCreatedBy }}
                              </small>
                              <small class="col-12" v-else>
                                Enviando em
                                {{
                                  doc.created | moment("DD/MM/YY à\\s HH:mm:ss")
                                }}
                                por {{ doc.createdBy }}
                              </small>
                            </div>
                          </div>
                        </perfect-scrollbar>
                      </template>
                      <template v-else>
                        <div
                          class="file-item bd-1 bd-gray-200 bg-gray-100 pd-t-10 pd-b-10 ht-70"
                        >
                          Nenhum documento foi enviado.
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="tab-pane" id="documentos-enviar">
              <upload-documentos></upload-documentos>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="preview.open"
      class="docs-preview-overlay"
      @click.self="fecharVisualizacao"
    >
      <div class="docs-preview-modal">
        <div class="docs-preview-header">
          <h6 class="mg-b-0">{{ preview.nome }}</h6>
          <a href="#" class="tx-24" @click.prevent="fecharVisualizacao">
            <i class="fa fa-times"></i>
          </a>
        </div>
        <div
          class="docs-preview-body"
          :class="{ 'docs-preview-body-pdf': preview.tipo === 'pdf' }"
          ref="previewBody"
        >
          <div v-if="preview.tipo === 'pdf'" class="docs-preview-pdf">
            <canvas
              v-for="page in preview.paginas"
              :key="'pdf-page-' + page"
              :ref="'pdfPage' + page"
              class="docs-preview-page"
            ></canvas>
          </div>
          <img
            v-else
            :src="preview.url"
            class="docs-preview-img"
            :alt="preview.nome"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import config from "@/config.js";
import { mapState } from "vuex";
import { EventBus } from "@/events/EventBus.js";
import Swal from "sweetalert2";

import FormDocs from "@/views/operational/imp/Form.Docs.Upload.vue";
import downloadjs from "downloadjs";
import JSZip from "jszip";
import ProcessService from "@/services/ProcessService.js";

const pdfjsCarregado = require("pdfjs-dist/legacy/build/pdf");
require("pdfjs-dist/legacy/build/pdf.worker.entry");

const pdfjsLib =
  pdfjsCarregado && typeof pdfjsCarregado.getDocument === "function"
    ? pdfjsCarregado
    : pdfjsCarregado.default;

export default {
  name: "operational-importation-form-documents",
  components: {
    "upload-documentos": FormDocs,
  },
  data() {
    return {
      documents: [],
      headers: {
        Authorization: `Bearer ${this.$store.state.credentials.accessToken}`,
      },
      documentSearch: "",
      documentFilter: "with",
      preview: {
        open: false,
        url: null,
        tipo: null,
        nome: "",
        paginas: 0,
      },
    };
  },
  methods: {
    loadDocuments() {
      this.$store.commit("setLoading", {
        show: true,
        label: "Carregando Documentos",
        description: "Carregando...",
      });

      Axios.get(
        `${config.env.API_DEFAULT.host}/importProcesses/${this.process.id}/documents`
      )
        .then((response) => {
          this.documents = response.data._embedded.documents.filter(doc => doc.deletedAt === null && (doc.deletedBy === null || doc.deletedBy === ''));
        })
        .catch((error) => {
          this.$store.commit("setLoading", {
            show: false,
          });
        });

      this.$store.commit("setLoading", {
        show: false,
      });
    },
    downloadManager(id, name, type) {
      if (type === "application/pdf" || type === "application/octet-stream") {
        Axios.post(`${config.env.API_DEFAULT.host}/documents/download/${id}`)
          .then((response) => {
            if (response.data.code === "ERROR") {
              Swal.fire(
                "Download de Documento",
                response.data.message,
                "error"
              );
            } else {
              const binaryString = window.atob(response.data);
              const binaryLen = binaryString.length;
              const bytes = new Uint8Array(binaryLen);

              for (let i = 0; i < binaryLen; i++) {
                const ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
              }

              const blob = new Blob([bytes], { type });
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = name;
              link.click();
            }
          })
          .catch((error) => {
            Swal.fire("Download de Documento", error.message, "error");
          });
      } else {
        Axios.post(
          `${config.env.API_DEFAULT.host}/documents/download/${id}`,
          null,
          { responseType: "blob" }
        )
          .then((response) => {
            if (response.data.code === "ERROR") {
              Swal.fire(
                "Download de Documento",
                response.data.message,
                "error"
              );
            } else {
              downloadjs(response.data, name);
            }
          })
          .catch((error) => {
            Swal.fire("Download de Documento", error.message, "error");
          });
      }
    },
    download(doc) {
      let filename = "";
      if (doc.originalFilename !== null && !doc.originalFilename) {
        filename = doc.originalFilename;
      } else {
        filename = doc.description;
      }

      this.downloadManager(doc.id, filename, doc.fileType);
    },
    obterBlobDocumento(doc) {
      const type = doc.fileType;

      if (type === "application/pdf" || type === "application/octet-stream") {
        return Axios.post(
          `${config.env.API_DEFAULT.host}/documents/download/${doc.id}`
        ).then((response) => {
          if (response.data.code === "ERROR") {
            throw new Error(response.data.message);
          }

          const binaryString = window.atob(response.data);
          const binaryLen = binaryString.length;
          const bytes = new Uint8Array(binaryLen);

          for (let i = 0; i < binaryLen; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          return new Blob([bytes], { type });
        });
      }

      return Axios.post(
        `${config.env.API_DEFAULT.host}/documents/download/${doc.id}`,
        null,
        { responseType: "blob" }
      ).then((response) => response.data);
    },
    baixarTodos(documentType) {
      const docs = documentType.docs || [];

      if (docs.length === 0) {
        return;
      }

      this.$store.commit("setLoading", {
        show: true,
        label: "Baixando Documentos",
        description: "Compactando arquivos...",
      });

      const zip = new JSZip();
      const usedNames = {};

      docs
        .reduce(
          (promise, doc) =>
            promise.then(() =>
              this.obterBlobDocumento(doc).then((blob) => {
                let filename = this.nomeDoArquivo(doc) || `documento-${doc.id}`;

                if (usedNames[filename] !== undefined) {
                  usedNames[filename] += 1;
                  const extIndex = filename.lastIndexOf(".");
                  filename =
                    extIndex > -1
                      ? `${filename.slice(0, extIndex)} (${usedNames[filename]})${filename.slice(extIndex)}`
                      : `${filename} (${usedNames[filename]})`;
                } else {
                  usedNames[filename] = 0;
                }

                zip.file(filename, blob);
              })
            ),
          Promise.resolve()
        )
        .then(() => zip.generateAsync({ type: "blob" }))
        .then((zipBlob) => {
          downloadjs(
            zipBlob,
            `${ProcessService.getTypeOfProcessReference(this.process)}-${documentType.description}.zip`
          );
        })
        .catch(() => {
          Swal.fire(
            "Baixar Documentos",
            "Não foi possível baixar todos os documentos.",
            "error"
          );
        })
        .then(() => {
          this.$store.commit("setLoading", { show: false });
        });
    },
    nomeDoArquivo(doc) {
      if (doc.originalFilename) {
        return doc.originalFilename;
      }
      return doc.description || "";
    },
    podeVisualizar(doc) {
      if (!doc) {
        return false;
      }

      const type = (doc.fileType || "").toLowerCase();
      const name = this.nomeDoArquivo(doc).toLowerCase();

      if (
        type === "application/pdf" ||
        (type === "application/octet-stream" && name.endsWith(".pdf")) ||
        name.endsWith(".pdf")
      ) {
        return true;
      }

      if (type.indexOf("image/") === 0 || /\.(jpe?g|png|gif|webp|bmp)$/.test(name)) {
        return true;
      }

      return false;
    },
    ehPdf(doc) {
      const type = (doc.fileType || "").toLowerCase();
      const name = this.nomeDoArquivo(doc).toLowerCase();

      return (
        type === "application/pdf" ||
        (type === "application/octet-stream" && name.endsWith(".pdf")) ||
        name.endsWith(".pdf")
      );
    },
    abrirPreview(blob, tipo, nome) {
      this.fecharVisualizacao();
      this.preview = {
        open: true,
        url: window.URL.createObjectURL(blob),
        tipo,
        nome,
        paginas: 0,
      };
    },
    async abrirPdf(bytes, nome) {
      this.fecharVisualizacao();
      const token = ++this._previewSeq;

      const loadingTask = pdfjsLib.getDocument({ data: bytes });
      this._pdfLoadingTask = loadingTask;

      let pdf;

      try {
        pdf = await loadingTask.promise;
      } catch (error) {
        if (token !== this._previewSeq) {
          return;
        }

        throw error;
      }

      if (token !== this._previewSeq) {
        loadingTask.destroy();
        return;
      }

      this._pdfDoc = pdf;
      this.preview = {
        open: true,
        url: null,
        tipo: "pdf",
        nome: nome || "",
        paginas: pdf.numPages,
      };

      await this.$nextTick();

      if (token !== this._previewSeq) {
        return;
      }

      await this.renderizarPaginas(pdf);
    },
    async renderizarPaginas(pdf) {
      const body = this.$refs.previewBody;
      const largura = body ? body.clientWidth - 48 : 900;

      for (let i = 1; i <= pdf.numPages; i++) {
        if (this._pdfDoc !== pdf) {
          return;
        }

        const page = await pdf.getPage(i);
        const base = page.getViewport({ scale: 1 });
        const scale = Math.min(Math.max(largura / base.width, 0.5), 2);
        const viewport = page.getViewport({ scale });
        const ref = this.$refs["pdfPage" + i];
        const canvas = Array.isArray(ref) ? ref[0] : ref;

        if (!canvas) {
          continue;
        }

        const ratio = window.devicePixelRatio || 1;
        canvas.width = Math.floor(viewport.width * ratio);
        canvas.height = Math.floor(viewport.height * ratio);
        canvas.style.width = Math.floor(viewport.width) + "px";
        canvas.style.height = Math.floor(viewport.height) + "px";

        await page.render({
          canvasContext: canvas.getContext("2d"),
          viewport,
          transform: ratio !== 1 ? [ratio, 0, 0, ratio, 0, 0] : null,
        }).promise;
      }
    },
    fecharVisualizacao() {
      this._previewSeq = (this._previewSeq || 0) + 1;

      if (this.preview.url) {
        window.URL.revokeObjectURL(this.preview.url);
      }

      if (this._pdfLoadingTask) {
        this._pdfLoadingTask.destroy();
        this._pdfLoadingTask = null;
        this._pdfDoc = null;
      }

      this.preview = {
        open: false,
        url: null,
        tipo: null,
        nome: "",
        paginas: 0,
      };
    },
    visualizar(doc) {
      if (!this.podeVisualizar(doc)) {
        return;
      }

      this.$store.commit("setLoading", {
        show: true,
        label: "Visualizar Documento",
        description: "Carregando...",
      });

      const tipoPreview = this.ehPdf(doc) ? "pdf" : "image";
      const mime = tipoPreview === "pdf" ? "application/pdf" : doc.fileType;

      const finalizar = () => {
        this.$store.commit("setLoading", { show: false });
      };

      if (tipoPreview === "pdf") {
        Axios.post(`${config.env.API_DEFAULT.host}/documents/download/${doc.id}`)
          .then((response) => {
            if (response.data && response.data.code === "ERROR") {
              Swal.fire("Visualizar Documento", response.data.message, "error");
              return;
            }

            const binaryString = window.atob(response.data);
            const binaryLen = binaryString.length;
            const bytes = new Uint8Array(binaryLen);

            for (let i = 0; i < binaryLen; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }

            return this.abrirPdf(bytes, doc.description);
          })
          .catch((error) => {
            Swal.fire("Visualizar Documento", error.message, "error");
          })
          .then(finalizar);
      } else {
        Axios.post(
          `${config.env.API_DEFAULT.host}/documents/download/${doc.id}`,
          null,
          { responseType: "blob" }
        )
          .then((response) => {
            if (response.data && response.data.code === "ERROR") {
              Swal.fire("Visualizar Documento", response.data.message, "error");
              return;
            }

            const blob =
              response.data instanceof Blob
                ? response.data
                : new Blob([response.data], { type: mime });

            this.abrirPreview(blob, "image", doc.description);
          })
          .catch((error) => {
            Swal.fire("Visualizar Documento", error.message, "error");
          })
          .then(finalizar);
      }
    },
    remover(documento) {
      Swal.fire({
        title: "Você tem certeza?",
        text: `Se você excluir o documento  ${documento.description}, não será possível recuperá-lo para uso posterior.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((response) => {
        if (response.value) {
          this.$store.commit("setLoading", {
            show: true,
            label: "Excluindo Documento",
            description: "Excluindo...",
          });

          Axios.post(
            `${config.env.API_DEFAULT.host}/documents/delete/${documento.id}`
          )
            .then((result) => {
              this.$store.commit("setLoading", { show: false });
              this.loadDocuments();
              if (result.data.code === "SUCCESS") {
                Swal.fire("Excluir Documento", result.data.message, "success");
              } else if (result.data.code === "ERROR") {
                Swal.fire("Excluir Documento", result.data.message, "error");
              } else {
                Swal.fire("Excluir Documento", result.data.message, "error");
              }
            })
            .catch((error) => {
              this.$store.commit("setLoading", { show: false });
              Swal.fire("Excluir Documento", error.data.message, "error");
            });
        }
      });
    },
  },

  computed: {
    ...mapState({
      process: (state) => state.ProcessStore.activeProcess,
      documentsTypes: (state) => state.ProcessStore.documentsTypes,
    }),
    listOfDocuments() {
      let documents = [];

      const { documentsTypes } = this;

      const porDataDeEnvio = (a, b) =>
        new Date(a.legacyCreated || a.created) -
        new Date(b.legacyCreated || b.created);

      if (documentsTypes !== undefined && documentsTypes.length > 0) {
        if (this.documents !== undefined && this.documents.length > 0) {
          documents = documentsTypes.flatMap((type) => {
            const docs = this.documents
              .filter((doc) => type.description === doc.documentTypeName)
              .sort(porDataDeEnvio);

            type.docs = docs;

            return type;
          });
        } else {
          documents = documentsTypes.flatMap((type) => {
            type.docs = [];

            return type;
          });
        }
      }

      if (this.documents.length > 0 && this.documentSearch != "") {
        const searchTerm = this.documentSearch.toString().toLowerCase();

        return this.documents.filter((item) => {
          const description = item.description
            ? item.description.toString().toLowerCase()
            : "";
          const documentTypeName = item.documentTypeName
            ? item.documentTypeName.toString().toLowerCase()
            : "";

          return (
            description.indexOf(searchTerm) > -1 ||
            documentTypeName.indexOf(searchTerm) > -1
          );
        }).sort(porDataDeEnvio);
      }
      return documents.sort((a, b) =>
        a.description.localeCompare(b.description)
      );
    },
    filteredDocumentTypes() {
      if (this.documentFilter === "with") {
        return this.listOfDocuments.filter(
          (type) => type.docs !== undefined && type.docs.length > 0
        );
      }

      if (this.documentFilter === "without") {
        return this.listOfDocuments.filter(
          (type) => type.docs === undefined || type.docs.length === 0
        );
      }

      return this.listOfDocuments;
    },
  },
  mounted() {
    const self = this;

    try {
      this.model = {
        ...this.process,
      };

      this.$store.dispatch("ProcessStore/getDocumentsType");
      this.loadDocuments();
    } catch (err) {
      this.$swal(
        "Documentos",
        "Não foi possível carregar a lista de documentos.",
        "error"
      );
    }
  },
  created() {
    this.model = {
      ...this.process,
    };

    this.documents = [];

    EventBus.$on("Operational.imp.Form.Docs.load", () => {
      this.loadDocuments();
    });
  },
  beforeDestroy() {
    this.fecharVisualizacao();
  },
  watch: {
    process() {
      this.model = {
        ...this.process,
      };
    },
  },
};
</script>

<style>
.doc-filtro-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #9ca3af;
}

.doc-filtro-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.doc-filtro-pill {
  display: inline-flex;
  align-items: center;
  padding: 5px 16px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #4b5563;
  line-height: 1.5;
  cursor: pointer;
  outline: none;
  box-shadow: none;
}

.doc-filtro-pill:focus,
.doc-filtro-pill:active {
  outline: none;
  box-shadow: none;
}

.doc-filtro-pill-on {
  background: #161635;
  border-color: #161635;
  color: #fff;
}

.doc-search-box {
  border-color: #d1d5db;
  background-color: #fff;
}

.doc-search-box .btn {
  background-color: #161635;
}

.docs-preview-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  padding: 24px;
}

.docs-preview-modal {
  display: flex;
  flex-direction: column;
  width: 96vw;
  max-width: 1600px;
  height: 90vh;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.docs-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
}

.docs-preview-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  background: #525659;
  display: flex;
  align-items: center;
  justify-content: center;
}

.docs-preview-body-pdf {
  align-items: flex-start;
  justify-content: flex-start;
}

.docs-preview-pdf {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px;
  box-sizing: border-box;
}

.docs-preview-page {
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
}

.docs-preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.modal-backdrop {
  position: relative !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}

.example-full {
  height: 100vh;
}

.example-full .btn-group .dropdown-menu {
  display: block;
  visibility: hidden;
  transition: all 0.2s;
}

.example-full .btn-group:hover > .dropdown-menu {
  visibility: visible;
}

.example-full label.dropdown-item {
  margin-bottom: 0;
}

.example-full .btn-group .dropdown-toggle {
  margin-right: 0.6rem;
}

.example-full .filename {
  margin-bottom: 0.3rem;
}

.example-full .btn-is-option {
  margin-top: 0.25rem;
}

.example-full .example-foorer {
  padding: 0.5rem 0;
  border-top: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
}

.example-full .edit-image img {
  max-width: 100%;
}

.example-full .edit-image-tool {
  margin-top: 0.6rem;
}

.example-full .edit-image-tool .btn-group {
  margin-right: 0.6rem;
}

.example-full .footer-status {
  padding-top: 0.4rem;
}

.example-full .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}

.example-full .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>
